import ImportContactsRoundedIcon from '@mui/icons-material/ImportContactsRounded';
import { webPortalApi } from '#config/web-portal-api';
import { AddressbookOption } from '#service/autocomplete-service/option';
import { getRequestOptions, formattedAddress } from '#helper';

class AddressbookOptionService {
  #searchFields;

  constructor(searchFields) {
    if (!searchFields?.length) {
      throw new Error('Search fields are not provided');
    }

    this.#searchFields = searchFields;
  }

  async fetchOptionsRaw(value, fetchOptions = {}) {
    const searchParams = new URLSearchParams({
      limit: 5,
      offset: 0,
      filterBy: this.#searchFields,
      filter: value
    });

    const contactsUrl = webPortalApi.buildApiUrl(`addressbook/contact/details?${searchParams.toString()}`);
    const res = await fetch(contactsUrl, { ...getRequestOptions(), ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const options = await res.json();
    return options;
  }

  getDescriptionByDetails(details) {
    const descriptionArray = [];
    this.#searchFields.forEach(field => {
      switch (field) {
        case 'firstName':
        case 'lastName':
          descriptionArray.push(details[field]);
          break;
        case 'company':
          descriptionArray.push(details.companyName);
          break;
        case 'address':
          descriptionArray.push(formattedAddress(details.address));
          break;
        default:
      }
    });

    return descriptionArray.join(' ,');
  }

  async getOptions(value, fetchOptions) {
    if (!value || this.#searchFields.some(f => f === 'minutes' || f === 'radius')) {
      return [];
    }

    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options.map(option => {
      const details = {
        address: {
          address1: option.address1,
          address2: option.address2,
          city: option.city,
          state: option.state,
          country: option.country,
          zipCode: option.zipCode
        },
        addressbookContactId: option.id,
        locations: option.locations,
        firstName: option.firstName,
        lastName: option.lastName,
        companyName: option.companyName,
        radius: option.locations?.[0]?.radius.toString(),
        minutes: (option.timedelta / 1000 / 60).toString()
      };
      const description = this.getDescriptionByDetails(details);

      return new AddressbookOption(description, ImportContactsRoundedIcon, details);
    });
  }
}
export default AddressbookOptionService;
